import type { FC, FormEvent, ReactNode } from 'react'

import { useState } from 'react'

import { Seo, Layout } from '@/components/generals'

const Contact: FC = (): ReactNode => {
    const [fullName, setFullName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [message, setMessage] = useState('')
    const [submitted, setSubmitted] = useState(false)
    const [failed, setFailed] = useState(false)

    const handleSubmit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
        event.preventDefault()
        setFailed(false)

        try {
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    FullName: fullName,
                    email,
                    Phone: phone,
                    Message: message
                })
            })

            if (!response.ok) {
                throw new Error('Request failed')
            }

            setSubmitted(true)
        } catch {
            setFailed(true)
        }
    }

    return (
        <Layout>
            <Seo title='Contact' description="Talk to us. Don't hesitate to say hi, we'd love to get to know you." />

            {/* Hero */}
            <div className='section'>
                <div className='container no-paddings'>
                    <div className='pricing-hero'>
                        <div className='center-title'>
                            <div className='title-holder'>
                                <div className='animate-on-load-01'>
                                    <h1 className='white-title'>Talk to us</h1>
                                </div>
                                <div className='animate-on-load-02'>
                                    <div className='experience-paragraph-holder'>
                                        <p>Don't hesitate to say hi, we'd love <br />to get to know you.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='animate-on-load-03'>
                        <div className='open-roles-cta-holder'>
                            <div className='open-roles-cta-container'>
                                <div className='open-roles-cta'><img src='/images/Open-Roles-Illustaion.svg' loading='eager' alt='' className='open-roles-illustation' />
                                    <div className='contact-form-block w-form'>
                                        <form id='wf-form-ContactForm' name='wf-form-ContactForm' onSubmit={handleSubmit} style={{ display: submitted ? 'none' : undefined }} className='contact-form'><input className='field-input w-input' maxLength={256} name='FullName' placeholder='Full Name' type='text' id='FullName' value={fullName} onChange={(event) => setFullName(event.target.value)} required /><input className='field-input w-input' maxLength={256} name='email' placeholder='biz@email.com' type='email' id='email' value={email} onChange={(event) => setEmail(event.target.value)} required /><input className='field-input w-input' maxLength={256} name='Phone' placeholder='+1 000111222' type='tel' id='Phone' value={phone} onChange={(event) => setPhone(event.target.value)} required /><textarea id='Message' name='Message' maxLength={5000} placeholder='Message' value={message} onChange={(event) => setMessage(event.target.value)} required className='field-input textarea w-input' /><input type='submit' className='button w-button' value='Submit' /></form>
                                        <div className='success-message w-form-done' style={{ display: submitted ? 'block' : 'none' }}>
                                            <div>Thank you! Your submission has been received!</div>
                                        </div>
                                        <div className='error-message w-form-fail' style={{ display: failed ? 'block' : 'none' }}>
                                            <div>Oops! Something went wrong while submitting the form.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='logo-grid-holder'>
                        <div className='w-layout-grid logo-grid'>
                            <div id='w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcd8-8f2c2147' className='logo-small-container'><img src='/images/Logo01.svg' loading='lazy' alt='Black+ Webflow Template by Wedoflow.com' className='logo-small' /></div>
                            <div id='w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcda-8f2c2147' className='logo-small-container'><img src='/images/Logo02.svg' loading='lazy' alt='Black+ Webflow Template by Wedoflow.com' className='logo-small' /></div>
                            <div id='w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcdc-8f2c2147' className='logo-small-container'><img src='/images/Logo03.svg' loading='lazy' alt='Black+ Webflow Template by Wedoflow.com' className='logo-small' /></div>
                            <div id='w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcde-8f2c2147' className='logo-small-container'><img src='/images/Logo04.svg' loading='lazy' alt='Black+ Webflow Template by Wedoflow.com' className='logo-small' /></div>
                            <div id='w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce0-8f2c2147' className='logo-small-container'><img src='/images/Logo05.svg' loading='lazy' alt='Black+ Webflow Template by Wedoflow.com' className='logo-small' /></div>
                            <div id='w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce2-8f2c2147' className='logo-small-container'><img src='/images/Logo06.svg' loading='lazy' alt='Black+ Webflow Template by Wedoflow.com' className='logo-small' /></div>
                            <div id='w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce4-8f2c2147' className='logo-small-container'><img src='/images/Logo07.svg' loading='lazy' alt='Black+ Webflow Template by Wedoflow.com' className='logo-small' /></div>
                            <div id='w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce6-8f2c2147' className='logo-small-container'><img src='/images/Logo08.svg' loading='lazy' alt='Black+ Webflow Template by Wedoflow.com' className='logo-small' /></div>
                        </div>
                        <div className='fade-in-move-on-scroll'>
                            <p>Trusted by Top-tier product campanies</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* FAQ */}
            <div className='section'>
                <div className='container'>
                    <div className='center-title'>
                        <div className='title-holder'>
                            <div className='fade-in-move-on-scroll'>
                                <h2 className='title'>Frequently asked questions</h2>
                            </div>
                            <div className='fade-in-move-on-scroll'>
                                <div className='experience-paragraph-holder'>
                                    <p>Everything you need to know about the product and billing.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='faq-holder'>
                        <div className='faq-container'>
                            <div className='faq-block'>
                                <div className='faq-heading'>
                                    <div className='faq-question-text'>Is there a free trial available?</div>
                                    <div className='faq-icon-holder'><img src='/images/Plus-Icon.svg' loading='lazy' alt='' className='faq-icon' /></div>
                                </div>
                                <div className='faq-answer-holder'>
                                    <div className='faq-answer'>Yes, you can try us for free for 30 days. If you want, we'll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.</div>
                                </div>
                            </div>
                            <div className='faq-block'>
                                <div className='faq-heading'>
                                    <div className='faq-question-text'>Can I change my plan later?</div>
                                    <div className='faq-icon-holder'><img src='/images/Plus-Icon.svg' loading='lazy' alt='' className='faq-icon' /></div>
                                </div>
                                <div className='faq-answer-holder'>
                                    <div className='faq-answer'>Yes, you can try us for free for 30 days. If you want, we'll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.</div>
                                </div>
                            </div>
                            <div className='faq-block'>
                                <div className='faq-heading'>
                                    <div className='faq-question-text'>What is your cancellation policy?</div>
                                    <div className='faq-icon-holder'><img src='/images/Plus-Icon.svg' loading='lazy' alt='' className='faq-icon' /></div>
                                </div>
                                <div className='faq-answer-holder'>
                                    <div className='faq-answer'>Yes, you can try us for free for 30 days. If you want, we'll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.</div>
                                </div>
                            </div>
                            <div className='faq-block'>
                                <div className='faq-heading'>
                                    <div className='faq-question-text'>Can other info be added to an invoice?</div>
                                    <div className='faq-icon-holder'><img src='/images/Plus-Icon.svg' loading='lazy' alt='' className='faq-icon' /></div>
                                </div>
                                <div className='faq-answer-holder'>
                                    <div className='faq-answer'>Yes, you can try us for free for 30 days. If you want, we'll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.</div>
                                </div>
                            </div>
                            <div className='faq-block'>
                                <div className='faq-heading'>
                                    <div className='faq-question-text'>How does billing work?</div>
                                    <div className='faq-icon-holder'><img src='/images/Plus-Icon.svg' loading='lazy' alt='' className='faq-icon' /></div>
                                </div>
                                <div className='faq-answer-holder'>
                                    <div className='faq-answer'>Yes, you can try us for free for 30 days. If you want, we'll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.</div>
                                </div>
                            </div>
                            <div className='faq-block'>
                                <div className='faq-heading'>
                                    <div className='faq-question-text'>How do I change my account email?</div>
                                    <div className='faq-icon-holder'><img src='/images/Plus-Icon.svg' loading='lazy' alt='' className='faq-icon' /></div>
                                </div>
                                <div className='faq-answer-holder'>
                                    <div className='faq-answer'>Yes, you can try us for free for 30 days. If you want, we'll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='open-roles-cta-holder'>
                        <div className='open-roles-cta-container'>
                            <div className='open-roles-cta'>
                                <div className='content-holder'>
                                    <h2 className='h3-title'>Still have questions?</h2>
                                    <div className='paragraph-open-roles'>
                                        <p>Can't find the answer you're looking for? Please chat to our friendly team.</p>
                                    </div>
                                </div>
                                <a href='mailto:hello@azwedo.com?subject=Black%20Plus' className='button w-button'>Email us here</a><img src='/images/Open-Roles-Illustaion.svg' loading='eager' alt='' className='open-roles-illustation' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Contact
